import React from 'react';
import { dehydrate, QueryClient } from '@tanstack/react-query';
import { ArrowLeftIcon } from 'icons';
import { GetStaticProps } from 'next';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { dtmConst, getBlocks, Main } from 'modules/dtm';
import { globalConst } from 'modules/global';

import { NextHead } from 'components';

const Index = () => {
  const t = useTranslations();

  return (
    <>
      <NextHead title={t('meta.dtm.title')} description={t('meta.dtm.description')} />

      <div className="max-w-screen mx-auto my-9 min-h-screen p-3 lg:p-0">
        <Link href={globalConst.pageNames.BLOCK_TEST}>
          <div className="m-4 inline-flex cursor-pointer items-center justify-start gap-2 font-semibold sm:m-0">
            <ArrowLeftIcon /> {t('common.ortga_qaytish')}
          </div>
        </Link>
        <Main />
      </div>
    </>
  );
};

export default Index;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const queryClient = new QueryClient();

  await queryClient.prefetchQuery({
    queryKey: [dtmConst.queryKeys.DTM_BLOCKS],
    queryFn: getBlocks
  });

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      messages: (await import(`../../messages/${locale}.json`)).default
    },
    revalidate: 604800
  };
};
